import moment from 'moment-timezone';

function getScheduleStatus(mintingStartAt, mintingEndAt) {
  var now = new Date().getTime();
  if (now < mintingStartAt) {
    return "UPCOMING";
  } else if (now > mintingEndAt) {
    return "TERMINATED";
  } else {
    return "MINTING";
  }
}
function shaveWalletAddress(address) {
  return address.slice(0, 5) + "..." + address.slice(-4);
}
function getScheduleDateByGMT(time) {
  var momentTime = moment(time);
  var timeZone = moment.tz.guess();
  return "".concat(momentTime.format("YY. M. D A hh:mm:ss"), " (").concat(momentTime.tz(timeZone).format("z Z"), ")");
}

export { getScheduleDateByGMT, getScheduleStatus, shaveWalletAddress };
